/*
Permite ejecutar acciones antes de hacer el link
Autor: Benjamín León
Fecha: 2024-11-29
*/
import React, { ReactNode, MouseEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { PageState } from '../interfaces/PageState'

interface CustomLinkProps {
  href: string // The URL to navigate to
  disabled?: boolean // Optional: Disable the link
  onBeforeNavigate?: () => void // Optional: Function to execute before navigation
  className: string
  children: ReactNode // Children components inside the link
  pageState?: PageState
}

const CustomLink: React.FC<CustomLinkProps> = ({
  href,
  disabled = false,
  onBeforeNavigate,
  className,
  children,
  pageState,
}) => {
  const navigate = useNavigate()

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault() // Prevent default click behavior

    if (disabled) {
      return
    }

    if (onBeforeNavigate) {
      onBeforeNavigate() // Call the function passed via props
    }

    if (href) {
      navigate(href, { state: pageState }) // Navigate to the target URL
    }
  }

  return (
    <Link to={href} onClick={handleClick} className={className}>
      {children}
    </Link>
  )
}

export default CustomLink
